import React, { useCallback, useState } from 'react';
import { Flex, Button, useToast, Text, Input, Icon } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { MdChevronRight } from 'react-icons/md';
import { useAuthContext } from '../AuthProvider';
import { useUserBoardGame } from '../hooks/useUserBoardGame';
import HomeHeader from '../components/HomeHeader';

const MyPage = () => {
  const { user, logout } = useAuthContext();
  const navigate = useNavigate();
  const [name, setName] = useState(user?.name || '');
  const { updateUserName } = useUserBoardGame(user?.uid || 'no-login');
  const toast = useToast();

  const handleInput = useCallback(
    (e: React.ChangeEvent) => {
      const { value } = e.target as HTMLInputElement;
      setName(value);
    },
    [setName]
  );

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      updateUserName(name);
      toast({
        title: '저장 성공',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });
    },
    [name, updateUserName, toast]
  );

  return (
    <Flex
      pos="relative"
      h="100%"
      flexDirection="column"
      align="center"
      px="1rem"
      pb={8}
    >
      <HomeHeader title="마이페이지" />
      <Flex my="10px" justify="space-between" alignItems="center" width="100%">
        <Text fontSize="18px" fontWeight="bold" mr="8px" wordBreak="keep-all">
          이름
        </Text>
        <Input
          focusBorderColor="#515151"
          p="1rem"
          placeholder="이름을 변경할 수 있습니다."
          value={name}
          onChange={handleInput}
          flexShrink={1}
        />
        <Button
          ml="8px"
          border="1px solid #D84E46"
          fontSize="12px"
          px="12px"
          height="28px"
          borderRadius="8px"
          bgColor="white"
          color="#D84E46"
          _active={{
            bgColor: '#FFE5E4',
          }}
          _hover={{
            bgColor: '#FFE5E4',
          }}
          onClick={handleSubmit}
        >
          변경하기
        </Button>
      </Flex>
      <Flex
        my="10px"
        onClick={() => navigate('/list')}
        justify="space-between"
        alignItems="center"
        width="100%"
      >
        <Text fontSize="18px" fontWeight="bold">
          내 보드게임 목록
        </Text>
        <Icon as={MdChevronRight} boxSize="18px" />
      </Flex>
      <Flex
        my="10px"
        onClick={logout}
        justify="space-between"
        alignItems="center"
        width="100%"
      >
        <Text fontSize="18px" fontWeight="bold">
          로그아웃
        </Text>
        <Icon as={MdChevronRight} boxSize="18px" />
      </Flex>
    </Flex>
  );
};

export default MyPage;
